(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["colectionss"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    // Seleciona os elementos dentro do escopo da seção atual
    const section = document.querySelector('.category-section');
    if (!section) return;

    const cards = section.querySelector('.category-cards');
    const btnLeft = section.querySelector('[id^="arrow-left-"]');
    const btnRight = section.querySelector('[id^="arrow-right-"]');
    let autoTimer;

    if (!cards || !btnLeft || !btnRight) return;

    const step = () => Math.round(cards.offsetWidth * 0.8);

    function startAuto() {
      // Limpa timer anterior para evitar múltiplos intervalos
      clearInterval(autoTimer);
      autoTimer = setInterval(() => {
        if (cards.scrollLeft + cards.clientWidth >= cards.scrollWidth - 5) {
          cards.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          cards.scrollBy({ left: step(), behavior: 'smooth' });
        }
      }, 3500);
    }
    function stopAuto() { clearInterval(autoTimer); }

    startAuto();
    cards.addEventListener('mouseenter', stopAuto);
    cards.addEventListener('mouseleave', startAuto);
    
    // Adiciona ouvintes de eventos de clique
    btnLeft.addEventListener('click', () => {
      stopAuto();
      cards.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    btnRight.addEventListener('click', () => {
      stopAuto();
      cards.scrollBy({ left: step(), behavior: 'smooth' });
    });

    // Eventos de toque
    let startX = 0;
    cards.addEventListener('touchstart', e => { 
      stopAuto(); 
      startX = e.touches[0].clientX; 
    }, { passive: true });
    
    cards.addEventListener('touchmove', e => {
      const delta = startX - e.touches[0].clientX;
      cards.scrollLeft += delta; // Movimento direto sem 'behavior'
      startX = e.touches[0].clientX;
    }, { passive: true });
    
    cards.addEventListener('touchend', () => startAuto());

    // Animação de fade-in
    const io = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          io.unobserve(entry.target); // Opcional: para animar apenas uma vez
        }
      });
    }, { threshold: 0.2 });

    section.querySelectorAll('.card-wrapper').forEach(c => io.observe(c));
  });

  } catch(e) { console.error(e); }
})();
})();
